import { CASA_TITLE, BANGALO_TITLE } from '../utils/available-accommodations'
import { gapi } from "gapi-script";

export const ACOMODATION_0 = 'Bangalô';
export const ACOMODATION_1 = 'Casa';
export const ACOMODATION_0_COLOR = '#D45A58'
export const ACOMODATION_1_COLOR = '#7A5487'

//monthIndex = 0 -> current month
//monthIndex = 1 -> next month
//...
export const getMonthWeeks = (monthIndex) => {
  const today = new Date()

  let month = today.getMonth() + monthIndex;
  let year = today.getFullYear();

  if (month > 11) {
    month -= 12
    year += 1
  }

  let firstWeekday = new Date(year, month, 1).getDay()
  var firstMonthDay = new Date(year, month, 1)
  var calendarDay = new Date(firstMonthDay)

  calendarDay.setDate(firstMonthDay.getDate() - firstWeekday)

  const weeks = []
  for (let week = 0; week < 6; week++) {
    if (week === 5 && (calendarDay.getDate() + 1) < 10)
      break

    const days = []

    for (let day = 0; day < 7; day++) {
      days.push(new Date(calendarDay));
      calendarDay.setDate(calendarDay.getDate() + 1)
    }

    weeks.push(days)
  }

  return weeks
}

export const getEventColor = (summary) => {
  if (summary.includes(ACOMODATION_0)) {
    return ACOMODATION_0_COLOR;
  } else if (summary.includes(ACOMODATION_1)) {
    return ACOMODATION_1_COLOR;
  }
}

export const mapEventsDays = (events) => {
  const eventsDayMap = {} //prevent more than one event from the same agenda
  const eventsDayLabelMap = {}

  events.forEach(event => {
    const eventStartDate = new Date(event.start.date)
    const eventEndDate = new Date(event.end.date)
    eventEndDate.setDate(eventEndDate.getDate() - 1)
    let currentDate = eventStartDate

    console.log(event);

    while (new Date(currentDate) <= eventEndDate) {
      const dateString = currentDate.toISOString().substring(0, 10)
      const eventId = dateString + '-' + event.summary

      if (!eventsDayMap[eventId]) {
        const eventsList = eventsDayLabelMap[dateString] ? eventsDayLabelMap[dateString] : []

        eventsDayMap[eventId] = true
        eventsDayLabelMap[dateString] = eventsList.concat([event.summary])
      }

      currentDate.setDate(currentDate.getDate() + 1)
    }
  })

  return eventsDayLabelMap;
}

export const getCalendarIDs = (accommodation) => {
  const calendarIds = [];

  if (accommodation.includes(BANGALO_TITLE))
    calendarIds.push(process.env.GATSBY_BANGALO_CALENDAR_ID)
  if (accommodation.includes(CASA_TITLE))
    calendarIds.push(process.env.GATSBY_CASA_CALENDAR_ID)

  return calendarIds
}

export const getCalendarEvents = (calendarID, callback) => {
  const today = new Date()
  const timeMin = new Date(today.getFullYear(), today.getMonth(), 1)
  timeMin.setDate(timeMin.getDate() - 7)

  function initiate() {
    gapi.client.init({
      apiKey: process.env.GATSBY_GOOGLE_API_KEY,
    })

    .then(function () {
      return gapi.client.request({
        path: `https://www.googleapis.com/calendar/v3/calendars/${calendarID}/events`,
        params: {
          timeMin: timeMin.toISOString(),
          showDeleted: false,
          singleEvents: true,
          orderBy: 'startTime'
        }
      });
    })

    .then(
      (response) => {
        let events = response.result.items;
        callback(calendarID, events);
      },
      function (err) {
        console.log(err);
        callback([]);
      }
    );
  }

  gapi.load("client", initiate);
}
